// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avo__badge {
  display: inline-flex;
  padding: 0.25rem 0.625rem;
  gap: 0.375rem;
  justify-content: center;
  align-items: center;
  border-radius: 0.375rem;
  border-width: 1px;
}
.avo__badge .badge_content {
  font-weight: 600;
  line-height: 1.25;
  text-align: center;
  text-transform: capitalize;
}
.avo__badge.registered {
  background-color: #eef7fa;
  border-color: #a6e7ff;
}
.avo__badge.registered .badge_content {
  color: #116584;
}
.avo__badge.draft, .avo__badge.drafted, .avo__badge.hide {
  background-color: #f9fafb;
  border-color: #b6bfcb;
}
.avo__badge.draft .badge_content, .avo__badge.drafted .badge_content, .avo__badge.hide .badge_content {
  color: #97a2b6;
}
.avo__badge.submitted, .avo__badge.accepted {
  background-color: #FDF2FA;
  border-color: #FAA7E0;
}
.avo__badge.submitted .badge_content, .avo__badge.accepted .badge_content {
  color: #DD2590;
}
.avo__badge.active, .avo__badge.approved, .avo__badge.published, .avo__badge.shown, .avo__badge.succeeded {
  background-color: #F1F8F6;
  border-color: #B0D6CB;
}
.avo__badge.active .badge_content, .avo__badge.approved .badge_content, .avo__badge.published .badge_content, .avo__badge.shown .badge_content, .avo__badge.succeeded .badge_content {
  color: #118462;
}
.avo__badge.inactive, .avo__badge.archive {
  background-color: #ebf0f6;
  border-color: #97a2b6;
}
.avo__badge.inactive .badge_content, .avo__badge.archive .badge_content {
  color: #4a5467;
}
.avo__badge.suspend {
  background-color: #FFF6ED;
  border-color: #FEB273;
}
.avo__badge.suspend .badge_content {
  color: #C4320A;
}
.avo__badge.blacklist {
  background-color: #F4EBFF;
  border-color: #D6BBFB;
}
.avo__badge.blacklist .badge_content {
  color: #7F56D9;
}
.avo__badge.rejected, .avo__badge.failed, .avo__badge.contract-rejected {
  background-color: #fef3f2;
  border-color: #fecdca;
}
.avo__badge.rejected .badge_content, .avo__badge.failed .badge_content, .avo__badge.contract-rejected .badge_content {
  color: #f04438;
}
.avo__badge.completed {
  background-color: #F5FAFF;
  border-color: #84CAFF;
}
.avo__badge.completed .badge_content {
  color: #1570EF;
}
.avo__badge.pending {
  background-color: #FFF6ED;
  border-color: #FEB273;
}
.avo__badge.pending .badge_content {
  color: #EC4A0A;
}
.avo__badge.valid {
  background-color: #F1F8F6;
  border-color: #B0D6CB;
}
.avo__badge.valid .badge_content {
  color: #118462;
}
.avo__badge.invalid {
  background-color: #fef3f2;
  border-color: #fecdca;
}
.avo__badge.invalid .badge_content {
  color: #f97066;
}`, "",{"version":3,"sources":["webpack://./src/components/commons/badge/badge.scss","webpack://./src/styles/_color.scss"],"names":[],"mappings":"AAEA;EACE,oBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AADF;AAGE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;AADJ;AAIE;EACE,yBCJS;EDKT,qBCHS;ADCb;AAGI;EACE,cCHO;ADEb;AAKE;EAGE,yBCxBS;EDyBT,qBCtBS;ADiBb;AAMI;EACE,cCvBO;ADmBb;AAQE;EAEE,yBCiDM;EDhDN,qBCkDM;ADzDV;AAQI;EACE,cCmDI;ADzDV;AAUE;EAKE,yBCXO;EDYP,qBCVO;ADFX;AAaI;EACE,cCTK;ADFX;AAeE;EAEE,yBCrDS;EDsDT,qBCnDS;ADqCb;AAeI;EACE,cCnDO;ADsCb;AAiBE;EACE,yBChBQ;EDiBR,qBCfQ;ADAZ;AAgBI;EACE,cCbM;ADDZ;AAkBE;EACE,yBAAA;EACA,qBCCQ;ADjBZ;AAiBI;EACE,cCEM;ADjBZ;AAmBE;EAGE,yBC1DK;ED2DL,qBCzDK;ADsCT;AAoBI;EACE,cCxDG;ADsCT;AAsBE;EACE,yBC9BM;ED+BN,qBC7BM;ADSV;AAqBI;EACE,cC5BI;ADSV;AAuBE;EACE,yBClDQ;EDmDR,qBCjDQ;AD4BZ;AAsBI;EACE,cChDM;AD4BZ;AAwBE;EACE,yBCtEO;EDuEP,qBCrEO;AD+CX;AAuBI;EACE,cCpEK;AD+CX;AAyBE;EACE,yBC1FK;ED2FL,qBCzFK;ADkET;AAwBI;EACE,cCzFG;ADmET","sourcesContent":["@import '../../../styles/color';\n\n.avo__badge{\n  display: inline-flex;\n  padding: 0.25rem 0.625rem;\n  gap: 0.375rem;\n  justify-content: center;\n  align-items: center;\n  border-radius: 0.375rem;\n  border-width: 1px;\n\n  .badge_content{\n    font-weight: 600;\n    line-height: 1.25;\n    text-align: center;\n    text-transform: capitalize;\n  }\n\n  &.registered{\n    background-color: $primary-10;\n    border-color: $primary-30;\n    .badge_content{\n      color: $primary-50;\n    }\n  }\n\n  &.draft,\n  &.drafted,\n  &.hide{\n    background-color: $neutral-10;\n    border-color: $neutral-40;\n    .badge_content{\n      color: $neutral-50;\n    }\n  }\n\n  &.submitted,\n  &.accepted{\n    background-color: $pink-10;\n    border-color: $pink-30;\n    .badge_content{\n      color: $pink-60;\n    }\n  }\n\n  &.active,\n  &.approved,\n  &.published,\n  &.shown,\n  &.succeeded{\n    background-color: $green-10;\n    border-color: $green-30;\n    .badge_content{\n      color: $green-60;\n    }\n  }\n\n  &.inactive,\n  &.archive{\n    background-color: $neutral-20;\n    border-color: $neutral-50;\n    .badge_content{\n      color: $neutral-70;\n    }\n  }\n\n  &.suspend{\n    background-color: $orange-10;\n    border-color: $orange-30;\n    .badge_content{\n      color: $orange-70;\n    }\n  }\n\n  &.blacklist{\n    background-color: $purple-10;\n    border-color: $purple-30;\n    .badge_content{\n      color: $purple-60;\n    }\n  }\n\n  &.rejected,\n  &.failed,\n  &.contract-rejected{\n    background-color: $red-10;\n    border-color: $red-30;\n    .badge_content{\n      color: $red-60;\n    }\n  }\n\n  &.completed{\n    background-color: $blue-10;\n    border-color: $blue-30;\n    .badge_content{\n      color: $blue-60;\n    }\n  }\n\n  &.pending{\n    background-color: $orange-10;\n    border-color: $orange-30;\n    .badge_content{\n      color: $orange-60;\n    }\n  }\n\n  &.valid{\n    background-color: $green-10;\n    border-color: $green-30;\n    .badge_content{\n      color: $green-60;\n    }\n  }\n\n  &.invalid{\n    background-color: $red-10;\n    border-color: $red-30;\n    .badge_content{\n      color: $red-50;\n    }\n  }\n\n}\n","$white: #ffffff;\n$black: #000000;\n$primary: #116584;\n$red: #f04438;\n\n$neutral-10: #f9fafb;\n$neutral-20: #ebf0f6;\n$neutral-30: #cdd5df;\n$neutral-40: #b6bfcb;\n$neutral-50: #97a2b6;\n$neutral-60: #788192;\n$neutral-70: #4a5467;\n$neutral-80: #101728;\n$neutral-90: #0a0a0a;\n\n$primary-10: #eef7fa;\n$primary-20: #ddf6ff;\n$primary-30: #a6e7ff;\n$primary-40: #2d96be;\n$primary-50: #116584;\n$primary-60: #07506d;\n$primary-70: #062d3d;\n$primary-80: #052431;\n$primary-90: #041b25;\n$primary-100: #021218;\n$primary-shadow: #073649;\n\n$red-10: #fef3f2;\n$red-20: #fee4e2;\n$red-30: #fecdca;\n$red-40: #fda29b;\n$red-50: #f97066;\n$red-60: #f04438;\n$red-70: #d92d20;\n$red-80: #b42318;\n$red-90: #912018;\n$red-100: #570f04;\n$red-shadow: #f0443840;\n\n$green-10: #F1F8F6;\n$green-20: #CFE6E0;\n$green-30: #B0D6CB;\n$green-40: #82C0AD;\n$green-50: #39987C;\n$green-60: #118462;\n$green-70: #0E6E52;\n$green-80: #0B5841;\n$green-90: #043B2B;\n$green-100: #031A14;\n$green-shadow: #11846240;\n\n$orange-10: #FFF6ED;\n$orange-20: #FFEACA;\n$orange-30: #FEB273;\n$orange-40: #FD853A;\n$orange-50: #FB6514;\n$orange-60: #EC4A0A;\n$orange-70: #C4320A;\n$orange-80: #9C2A10;\n$orange-90: #7E2410;\n$orange-100: #2D160C;\n$orange-shadow: #EC4A0A40;\n\n$blue-10: #F5FAFF;\n$blue-20: #DEEFFF;\n$blue-30: #84CAFF;\n$blue-40: #53B1FD;\n$blue-50: #2E90FA;\n$blue-60: #1570EF;\n$blue-70: #175CD3;\n$blue-80: #1849A9;\n$blue-90: #194185;\n$blue-100: #06214F;\n$blue-shadow: #1570EF40;\n\n$purple-10: #F4EBFF;\n$purple-20: #E9D7FE;\n$purple-30: #D6BBFB;\n$purple-40: #B692F6;\n$purple-50: #9E77ED;\n$purple-60: #7F56D9;\n$purple-70: #6941C6;\n$purple-80: #53389E;\n$purple-90: #42307D;\n$purple-100: #180947;\n$purple-shadow: #6D118440;\n\n$pink-10: #FDF2FA;\n$pink-20: #FFDEF5;\n$pink-30: #FAA7E0;\n$pink-40: #F670C7;\n$pink-50: #EE46BC;\n$pink-60: #DD2590;\n$pink-70: #C11574;\n$pink-80: #9E165F;\n$pink-90: #851651;\n$pink-100: #851651;\n$pink-shadow: #DD259040;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
